<template>
  <div class="form-container">
    <vxe-form v-bind="formOptions" v-on="formEvents"></vxe-form>
  </div>
</template>

<script setup>
import { reactive,defineProps,onMounted,defineEmits,computed } from 'vue'
import { VxeUI } from 'vxe-pc-ui'
import convertToFirstLetter from '@/utils/pingyingHelper'
import request from '@/request/request'
import  showMessage  from '@/utils/showmessage'
const isEdit = computed(() => props.initialData?.usefule === '修改')
// ==================== Props ====================
const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ usefule: '新增', Customer: {} })
  },

})
onMounted(() => {

    if (props.initialData.usefule === '修改') {
        let customer = props.initialData.Customer
        Object.assign(formData, {
            ID: customer.id ?? 0,
            BH: customer.bh ?? '',
            KHMC: customer.khmc ?? '',
            LXR: customer.lxr ?? '',
            LXDH: customer.lxdh ?? '',
            ZJC: customer.zjc ?? '',
            YSK: customer.ysk ?? 0,
            SE: customer.se ?? 0
        })
       
    }
})
const emit = defineEmits(['submit'])
// 表单绑定的数据对象（与后端属性一一对应）
const formData = reactive({
  ID: 0,
  BH: '',       // 编号
  KHMC: '',     // 客户名称
  LXR: '',      // 联系人
  LXDH: '',     // 联系电话
  ZJC: '',      // 助记词
  YSK: 0,       // 应收款
  SE: 0         // 税额
})

// 表单配置项
const formOptions = reactive({
  titleWidth: 100,   // 标签宽度
  data: formData,
  // 新增：校验规则配置
  rules: {
    KHMC: [
      { required: true, message: '请输入客户名称' }
    ],
    ZJC: [
      { required: true, message: '请输入助记词' }
    ]
  },
  items: [
      {
          field: 'KHMC', title: '客户名称', span: 12, itemRender: {
              name: 'VxeInput', props: { placeholder: '请输入客户名称' },
              events: {
                  input: ( slorParams, { value }) => {
                      formData.ZJC = convertToFirstLetter(value)
                  }
              }
          }
      },// 监听输入事件，实时转换拼音首字母

    { field: 'LXR', title: '联系人', span: 12, itemRender: { name: 'VxeInput', props: { placeholder: '请输入联系人' } } },
    { field: 'LXDH', title: '联系电话', span: 12, itemRender: { name: 'VxeInput', props: { placeholder: '请输入联系电话' } } },
    { field: 'ZJC', title: '助记词', span: 12, itemRender: { name: 'VxeInput', props: { placeholder: '请输入助记词' } } },
    { field: 'YSK', title: '应收款', span: 12, itemRender: { name: 'VxeNumberInput', props: { placeholder: '请输入应收款', digits: 2 , disabled: isEdit.value }}}, // 修改时禁用} 
    { field: 'SE', title: '税额', span: 12, itemRender: { name: 'VxeNumberInput', props: { placeholder: '请输入税额', digits: 2, disabled: isEdit.value }}}, // 修改时禁用 } } },
    // 按钮组
    {
      align: 'center',
      span: 24,
      itemRender: {
        name: 'VxeButtonGroup',
        options: [
          { type: 'submit', content: '提交', status: 'primary' },
          { type: 'reset', content: '重置' }
        ]
      }
    }
  ]
})

// 表单事件处理
const formEvents = {
 async submit()  {
        if (props.initialData.usefule == '新增') {
            // 提交时 formData 中的数据可以直接传给后端
            let res = await request.post('/LinkMan/AddNew', formData)
            if (showMessage(res)) {
                emit('submit')
            }
        }
        else {
            let res = await request.post('/LinkMan/Update', formData)
            if (showMessage(res)) {
                emit('submit')
            }
        }
    },
    reset() {
        VxeUI.modal.message({ content: '已重置', status: 'info' })
    }
}
</script>